import PreviewPanel from './PreviewPanel.view';

export default PreviewPanel;
